// extracted by mini-css-extract-plugin
module.exports = {"amountRow":"Amount_amountRow__--zWw","amount":"Amount_amount__2UxuK","tip":"Amount_tip__1Y9_q","tipHeader":"Amount_tipHeader__3zkcT","tipsWrap":"Amount_tipsWrap__32Km-"};